// Copyright (c) Microsoft Corporation. All rights reserved.

import "./App.css";

import * as microsoftTeams from "@microsoft/teams-js";

import Constants, { WegoConfig } from "./AppConstants";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";

import SampleAppConfiguration from "./pages/SampleAppConfiguration";
import SampleAppPrivacy from "./pages/SampleAppPrivacy";
import SampleAppTermsOfUse from "./pages/SampleAppTermsOfUse";
import WegoBrowserHost from "./wego/hosts/WegoBrowserHost";
import WegoBrowserRedirect from "./wego/auth/WegoBrowserRedirect";
import WegoTeamsHost from "./wego/hosts/WegoTeamsHost";

function App() {

  if (window.parent === window.self) {
    // Browser-based routes. Used for debugging only.
    return (
      <Router>
        <Switch>
          <Route exact path="/AuthEnd">
            <WegoBrowserRedirect
              wegoConfiguration={WegoConfig}
            />
          </Route>
          <Route exact path="/privacy" component={SampleAppPrivacy} />
          <Route exact path="/termsofuse" component={SampleAppTermsOfUse} />
          <Route exact path="/configure" component={SampleAppConfiguration} />

          <Route exact path="/sampleapp">
            <WegoBrowserHost
              wegoConfiguration={WegoConfig}
              appName={Constants.SampleApp.appName}
              appMeetingType={Constants.SampleApp.appMeetingType}
              appPreMeetingType={Constants.SampleApp.appPreMeetingType}
              appId={Constants.SampleApp.id} />
          </Route>
        </Switch>
      </Router>
    );
  }

  // Routes exposed in Teams. 
  microsoftTeams.initialize();
  return (
    <Router>
      <Switch>
        <Route exact path="/configure/:appName">
          <SampleAppConfiguration />
        </Route>

        <Route path="/apps/sampleapp">
          <WegoTeamsHost
            wegoConfiguration={WegoConfig}
            appName={Constants.SampleApp.appName}
            appMeetingType={Constants.SampleApp.appMeetingType}
            appPreMeetingType={Constants.SampleApp.appPreMeetingType}
            appId={Constants.SampleApp.id} />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
